<template>
    <main class="expense-edit-page">
        <section class="expense-edit-card">
            <header class="expense-edit-header">
                <div class="expense-edit-title">
                    <el-button class="expense-back-button" icon="el-icon-arrow-left"
                               :aria-label="$t('common.back')"
                               @click.native.prevent="goBack"></el-button>
                    <h1>{{$t('createExpense.title')}}</h1>
                </div>
                <el-button class="expense-save-button" type="primary" :disabled="!initialDataLoaded || buttonDisabledStatus || saveRequestPending"
                           :loading="saveRequestPending"
                           @click.native.prevent="createExpense">{{$t('common.saveAndClose')}}</el-button>
            </header>

            <el-alert v-if="loadError !== ''" :title="loadError" type="error" :closable="false" show-icon></el-alert>
            <el-form v-if="initialDataLoaded" class="expense-modern-form" label-width="0px" v-loading="loading">
                <el-form-item class="expense-form-row">
                    <span class="expense-form-label">{{$t('createExpense.description')}}</span>
                    <el-input class="expense-line-textarea" type="textarea" :autosize="{minRows: 1}"
                              v-model="expense.expenseDescription"

                              :placeholder="$t('createExpense.expenseDescriptionPlaceholder')"></el-input>
                </el-form-item>
                <el-form-item class="expense-form-row">
                    <span class="expense-form-label">{{$t('createExpense.total')}}</span>
                    <el-input class="expense-line-input" inputmode="decimal"
                              :placeholder="$t('createExpense.total')"
                              v-model="expense.total"></el-input>
                </el-form-item>
                <el-form-item class="expense-form-row">
                    <span class="expense-form-label">{{$t('createExpense.tax')}}</span>
                    <el-input class="expense-line-input" inputmode="decimal"
                              :placeholder="$t('createExpense.tax')"
                              v-model="expense.tax"></el-input>
                </el-form-item>
                <el-form-item class="expense-form-row">
                    <span class="expense-form-label">{{$t('createExpense.tip')}}</span>
                    <el-input class="expense-line-input" inputmode="decimal"
                              :placeholder="$t('createExpense.tip')"
                              v-model="expense.tip"></el-input>
                </el-form-item>
                <el-form-item class="expense-form-row">
                    <span class="expense-form-label">{{$t('createExpense.expenseDate')}}</span>
                    <el-date-picker class="expense-line-date" :editable=false type="date"
                                    :placeholder="$t('createExpense.expenseDate')"
                                    format="MMM dd, yyyy" v-model="expense.expenseDate" :clearable=false></el-date-picker>
                </el-form-item>
                <el-form-item class="expense-form-row">
                    <span class="expense-form-label">{{$t('createExpense.merchant')}}</span>
                    <el-input class="expense-line-input" v-model="expense.merchant"
                              :placeholder="$t('createExpense.merchantPlaceholder')"></el-input>
                </el-form-item>
                <el-form-item class="expense-form-row expense-category-row">
                    <span class="expense-form-label">{{$t('common.category')}}</span>
                    <div class="expense-category-control">
                        <el-select class="expense-line-select" v-model="expense.categoryUUID" :placeholder="$t('createExpense.categoryPlaceholder')">
                            <el-option v-for="item in activeCategoryList"
                                       :key="item.innerUUID"
                                       :label="item.name"
                                       :value="item.innerUUID">
                            </el-option>
                        </el-select>
                        <el-button class="expense-add-category-button" type="text" @click="openCategoryDiagory">
                            <span class="expense-add-category-icon"><i class="el-icon-plus"></i></span>
                            <span>{{$t('createExpense.addNewCategory')}}</span>
                        </el-button>
                    </div>
                </el-form-item>

                <div class="expense-photo-list" v-if="activeFileList.length > 0">
                    <div class="expense-photo-card" v-for="file in activeFileList" :key="file.innerUUID">
                        <el-image class="expense-photo-preview" :src="file.url" fit="cover">
                            <div slot="placeholder" class="remote-image-loading">
                                <i class="el-icon-loading"></i>
                            </div>
                        </el-image>
                        <el-button class="expense-photo-delete" @click="handleRemove(file.innerUUID)" type="text">{{$t('createExpense.deletePhoto')}}</el-button>
                    </div>
                </div>

                <div class="expense-upload-row" v-if='activeFileList.length==0'>
                    <el-upload
                            :action=requestURL
                            :show-file-list="false"
                            :on-success="handleSuccess"
                            :on-error="handleUploadError"
                            :before-upload="onBeforeUpload"
                            :data="uploadData"
                            accept="image/jpeg,image/png,image/bmp">
                        <el-button class="expense-upload-button" :loading="attachPhotosStatus">
                            <span class="expense-upload-icon"><i class="el-icon-paperclip"></i></span>
                            <span class="expense-upload-text">
                                <strong>{{$t('createExpense.addPhoto')}}</strong>
                            </span>
                        </el-button>
                    </el-upload>
                </div>

                <el-dialog :title="$t('createExpense.addNewCategory')" :visible.sync="categoryDiagoryStatus" width="720px"
                           custom-class="expense-category-dialog">
                            <div class="expense-category-dialog-list">
                                <template v-for="item in categoryList">
                                <div class="expense-category-dialog-row" :key="item.innerUUID" v-if="item.syncStatus!=1">
                                    <span v-if="item.isNew!=1" class="expense-category-dialog-name">{{ item.name }}</span>
                                    <el-input v-else class="expense-category-dialog-input" v-model="item.name"
></el-input>
                                    <el-button v-if="item.isNew!=1" class="expense-category-dialog-delete" type="text"
                                               @click="deleteCategory(item.innerUUID,item.isNew)">{{$t('createExpense.deleteCategory')}}</el-button>
                                    <el-button v-else class="expense-category-dialog-delete" type="text"
                                               @click="deleteCategory(item.innerUUID,1)">{{$t('createExpense.deleteCategory')}}</el-button>
                                </div>
                                </template>
                            </div>
                            <el-button class="expense-category-dialog-add" type="text" @click="addCategory()">
                                <span class="expense-category-dialog-add-icon"><i class="el-icon-plus"></i></span>
                                <span>{{$t('createExpense.addCategory')}}</span>
                            </el-button>
                            <div slot="footer" class="dialog-footer">
                                <el-button class="expense-category-dialog-close" @click="categoryDiagoryStatus=false">{{$t('common.close')}}</el-button>
                            </div>
                        </el-dialog>
            </el-form>
        </section>
    </main>
</template>

<script>
    import {uuid, timest, toTmpTime} from '@/utils/validate'
    import {
        isValidExpenseAmount,
        trimmedExpenseCategoryName
    } from '@/utils/expenseInputValidation'
    import {syncCompanySelection} from '@/utils/company'
    import {
        EXPENSE_IMAGES_FOLDER,
        getDownloadV2Url,
        getFileUploadUrl,
        getUploadRemoteKey,
        prepareFileUpload,
        takeUploadInnerUUID,
        discardPreparedFileUpload
    } from '@/utils/fileUpload'


    export default {
        data() {
            return {
                buttonDisabledStatus: false,
                saveRequestPending: false,
                expense: {
                    "expenseDate": new Date(),
                    "expenseDescription": "",
                    "merchant": "",
                    "tax": 0,
                    "tip": 0,
                    "total": 0,
                    "categoryUUID": ""
                },
                fileList: [],
                attachPhotosStatus: false,
                requestURL: "",
                uploadData: {
                    email: ""
                },
                uploadFileMap: {},
                company: null,
                loading: false,
                initialDataLoaded: false,
                loadError: '',
                categoryList: [],
                categoryDiagoryStatus: false,
                newCategoryList: []
            }
        },
        computed: {
            activeFileList() {
                return this.fileList.filter(file => file.syncStatus != 1);
            },
            activeCategoryList() {
                return this.categoryList.filter(category => category.syncStatus != 1);
            }
        },

        methods: {
            showValidationError(messageKey) {
                this.$message.error(this.$t(messageKey));
            },
            validateExpense() {
                const amountFields = ['total', 'tax', 'tip'];
                for (let i = 0; i < amountFields.length; i++) {
                    const field = amountFields[i];
                    if (!isValidExpenseAmount(this.expense[field])) {
                        this.showValidationError('createExpense.amountInvalid');
                        return false;
                    }
                }
                for (let i = 0; i < this.categoryList.length; i++) {
                    const category = this.categoryList[i];
                    if (category.isNew == 1 && category.syncStatus != 1) {
                        const name = trimmedExpenseCategoryName(category.name);
                        if (name.length === 0) {
                            this.showValidationError('createExpense.categoryRequired');
                            return false;
                        }
                        category.name = name;
                    }
                }
                return true;
            },
            buildExpenseImageForRequest(fileInfo, expenseUUID, syncStatus) {
                return {
                    accessDate: timest(),
                    createDate: timest(),
                    imageIsNew: 0,
                    imagePath: fileInfo.imagePath,
                    innerUUID: fileInfo.innerUUID,
                    companyUUID: this.company.innerUUID,
                    expenseUUID: expenseUUID,
                    syncStatus: syncStatus,
                    remoteKey: fileInfo.remoteKey,
                    transferStatusRaw: 1,
                    imageSchemaVersion: 1
                };
            },
            openCategoryDiagory() {
                this.categoryDiagoryStatus = true;
            },
            goBack() {
                let self = this;
                self.$router.push('/expense');
            },
            addCategory() {
                let newObj = {
                    "name": "",
                    "innerUUID": uuid(null, 37),
                    "syncStatus": 0,
                    "isNew": 1,
                    "companyUUID": this.company.innerUUID
                };
                this.categoryList.push(newObj);
            },
            deleteCategory(innerUUID, oldOrNew) {
                if (oldOrNew == 0 || oldOrNew == undefined) {
                    for (let i = 0; i < this.categoryList.length; i++) {
                        if (this.categoryList[i].innerUUID == innerUUID) {
                            this.categoryList[i].syncStatus = 1;
                            if (this.expense.categoryUUID === innerUUID) {
                                this.expense.categoryUUID = '';
                            }
                            break;
                        }
                    }
                } else if (oldOrNew == 1) {
                    for (let i = 0; i < this.categoryList.length; i++) {
                        if (this.categoryList[i].innerUUID == innerUUID) {
                            this.categoryList.splice(i--, 1);
                            break;
                        }
                    }
                }
            },
            createExpense() {
                if (!this.initialDataLoaded || this.saveRequestPending || this.company == null) {
                    return;
                }
                if (!this.validateExpense()) {
                    return;
                }
                let that = this;

                let createCategoryList = [];
                for (let i = 0; i < this.categoryList.length; i++) {
                    let category = this.categoryList[i];
                    //删除的category
                    if (category.syncStatus == 1) {
                        let needCreateCategory = {
                            accessDate: timest(),
                            createDate: timest(),
                            innerUUID: category.innerUUID,
                            isDelete: 0,
                            name: category.name,
                            syncStatus: 1,
                            fromClient: 3,
                            companyUUID: this.company.innerUUID
                        };
                        createCategoryList.push(needCreateCategory);
                    }

                    if (category.isNew == 1) {
                        let needCreateCategory = {
                            accessDate: timest(),
                            createDate: timest(),
                            innerUUID: category.innerUUID,
                            isDelete: 0,
                            name: category.name,
                            syncStatus: 0,
                            fromClient: 3,
                            companyUUID: this.company.innerUUID
                        };
                        createCategoryList.push(needCreateCategory);
                    }

                }
                //新创建的category
                /*for (let i = 0; i < this.newCategoryList.length; i++) {
                    let category = this.newCategoryList[i];
                    //删除的category
                    let needCreateCategory = {
                        accessDate: timest(),
                        createDate: timest(),
                        innerUUID: category.innerUUID,
                        isDelete: 0,
                        name: category.name,
                        syncStatus: 0,
                        fromClient: 3
                    };
                    createCategoryList.push(needCreateCategory);
                }*/


                let expenseUUID = uuid(null, 37);
                let activeImage = this.activeFileList.length > 0 ? this.activeFileList[0] : null;
                let companyLogo = activeImage != null ? this.buildExpenseImageForRequest(activeImage, expenseUUID, 0) : null;
                this.saveRequestPending = true;
                this.loading = true;
                this.buttonDisabledStatus = true;
                return this.$axios.post('web_create_expense', {
                    params: {
                        "expense": {
                            accessDate: timest(),
                            createDate: timest(),
                            innerUUID: expenseUUID,
                            companyUUID: this.company.innerUUID,
                            expenseDate: toTmpTime(that.expense.expenseDate),
                            expenseDescription: that.expense.expenseDescription,
                            imageIsNew: 0,
                            imagePath: "",
                            merchant: that.expense.merchant,
                            tax: that.expense.tax,
                            tip: that.expense.tip,
                            total: that.expense.total,
                            categoryUUID: that.expense.categoryUUID,
                            expenseImageUUIDArrayKey: activeImage != null ? activeImage.innerUUID : "",
                            syncStatus: 0,
                            fromClient: 3
                        },
                        "categoryList": createCategoryList,
                        companyLogo: companyLogo
                    }
                }).then(response => {
                    if (response.data.errorCode !== 0) {
                        throw new Error('Expense create failed');
                    }
                    that.$router.push('/expense');
                }).catch(function () {
                    that.$message.error(that.$t('common.saveFailed'));
                }).finally(function () {
                    that.loading = false;
                    that.buttonDisabledStatus = false;
                    that.saveRequestPending = false;
                })
            },

            queryCategoryList() {
                this.loading = true;
                this.buttonDisabledStatus = true;
                this.initialDataLoaded = false;
                this.loadError = '';
                let that = this;
                return this.$axios.post('query_category_list', {
                    params: {
                        appVersion: 700,
                        syncSuccessDate: '0',
                        fromClient: 3,
                        companyUUID: this.company.innerUUID
                    }
                }).then(response => {
                    if (response.data.errorCode !== 0) {
                        throw new Error('Expense category query failed');
                    }
                    const dataList = Array.isArray(response.data.dataList) ? response.data.dataList : [];
                    const categoryList = JSON.parse(JSON.stringify(dataList));
                    this.categoryList = categoryList.filter(category => category != null
                        && (category.companyUUID == null || category.companyUUID === this.company.innerUUID)
                        && Number(category.syncStatus) !== 1);
                    that.loading = false;
                    that.buttonDisabledStatus = false;
                    that.initialDataLoaded = true;
                }).catch(function () {
                    that.loading = false;
                    that.buttonDisabledStatus = true;
                    that.initialDataLoaded = false;
                    that.loadError = that.$t('expense.categoryLoadFailed');
                })
            },
            async loadPage() {
                this.loading = true;
                this.buttonDisabledStatus = true;
                this.initialDataLoaded = false;
                this.loadError = '';
                try {
                    const response = await this.$axios.post('query_setting_and_company', {params: {}});
                    if (response.data.errorCode !== 0) {
                        throw new Error('Company and setting query failed');
                    }
                    const selectedData = syncCompanySelection(response.data);
                    if (selectedData == null) {
                        throw new Error('Selected company data is missing');
                    }
                    this.company = selectedData.company;
                    await this.queryCategoryList();
                } catch {
                    this.loading = false;
                    this.buttonDisabledStatus = true;
                    this.initialDataLoaded = false;
                    this.loadError = this.$t('common.loadFailed');
                }
            },
            ///////////////上传///////////////
            handleRemove(fileName) {
                for (let i = 0; i < this.fileList.length; i++) {
                    if (this.fileList[i].innerUUID === fileName) {
                        this.fileList.splice(i--, 1);
                    }
                }
            },
            onBeforeUpload(file) {
                prepareFileUpload(this.uploadData, this.uploadFileMap, file, EXPENSE_IMAGES_FOLDER);
                this.attachPhotosStatus = true;
                return true;
            },
            handlePictureCardPreview() {

            },
            handleUploadError(error, file) {
                discardPreparedFileUpload(this.uploadFileMap, file);
                this.attachPhotosStatus = false;
                this.$message.error(this.$t('createExpense.photoUploadFailed'));
            },
            handleSuccess(res, file) {
                this.attachPhotosStatus = false;
                if (res != null && res.errorCode === 0 && Array.isArray(res.uploadFileList)
                    && res.uploadFileList.length === 1) {
                    this.$message({
                        type: 'info',
                        message: this.$t('common.uploadSuccess'),
                        duration: 6000
                    });
                    const innerUUID = takeUploadInnerUUID(this.uploadFileMap, file);
                    const remoteKey = getUploadRemoteKey(EXPENSE_IMAGES_FOLDER, innerUUID);
                    let fileInfo = {
                        url: getDownloadV2Url(this.$store.state.requestURL, remoteKey),
                        innerUUID: innerUUID,
                        imagePath: innerUUID + ".jpg",
                        remoteKey: remoteKey,
                        syncStatus: 0
                    };
                    this.fileList.push(fileInfo);
                } else {
                    discardPreparedFileUpload(this.uploadFileMap, file);
                    this.$message.error(this.$t('createExpense.photoUploadFailed'));
                }
            },
            ///////////////上传///////////////

        },
        mounted() {
            this.requestURL = getFileUploadUrl(this.$store.state.requestURL);
            this.uploadData.email = JSON.parse(localStorage.getItem("loginInformation")).objectData.email;
            this.loadPage();
        }
    }
</script>
